import { useCallback } from 'react';
import { RowPreparedEvent } from 'devextreme/ui/data_grid';

export const useOnRowPrepared = <TData,>(customizeRow?: (rowData: TData) => string | undefined) => {
  const onRowPrepared = useCallback((e: RowPreparedEvent<TData>) => {
    if (e.data) {
      const color = customizeRow?.(e.data);
      if (color) e.rowElement.style.background = color;
    }
  }, []);

  return {
    onRowPrepared,
  };
};
